module.exports = __webpack_public_path__ + "img/podium_5153.a9b37d24.jpg";